/**
 * The initial-in-a-circle for one person at the table.
 *
 * Shared by the roster and the verdict sheet, so a person is the same colour
 * and the same letter wherever they appear. Accounts carry the household
 * colours CookRow already uses; a dictated eater stays neutral, which is how
 * the avatar itself says who can answer for themselves and who is being spoken
 * for.
 */
import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { Paprika } from '../../styles/theme';
import type { TableMember } from '../../hooks/useHouseholdEaters';

export function EaterAvatar({ member, size = 26 }: { member: TableMember; size?: number }) {
  const background = member.isAccount
    ? member.isSelf
      ? Paprika.accent
      : Paprika.textSecondary
    : Paprika.bgSunk;
  const color = member.isAccount ? '#ffffff' : Paprika.textSecondary;

  return (
    <View
      style={[
        styles.avatar,
        { width: size, height: size, borderRadius: size / 2, backgroundColor: background },
      ]}
    >
      <Text style={[styles.avatarText, { color, fontSize: Math.round(size * 0.42) }]}>
        {member.initial}
      </Text>
    </View>
  );
}

const styles = StyleSheet.create({
  avatar: {
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  avatarText: {
    fontFamily: 'Inter-SemiBold',
    fontWeight: '600',
  },
});
